const React = require('react')
const translate = require('../../translate');


const OccupancyHeaderWithLimits = ({ max_occupancy, critical_occupancy, occupancy, language }) => {
    let isOverMax = occupancy >= max_occupancy;
    let isCritical = occupancy >= critical_occupancy;
    let text;
    if (isOverMax) {
        text = translate(language, 'EXCESSIVE');
    } else if (isCritical) {
        text = translate(language, 'CRITICAL');
    } else {
        text = translate(language, 'NORMAL');
    }

    let className = 'p-2 ';
    if (isOverMax) {
        className += 'bg-error';
    } else if (isCritical) {
        className += 'bg-warning';
    } else {
        className += 'bg-success';
    }

    let wideText = text.length >= 10;

    return <React.Fragment>
        <div className="text-left pt-2">
            {translate(language, 'Current occupancy:')}
        </div>

        <div className={className} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className="columns col-gapless">
                <div className={'column ' + (wideText ? 'col-sm-12' : '') + ' col-8 text-left'}>
                    <div className="h5" style={{ fontSize: '250%', paddingTop: '6px' }}>
                        {text}
                    </div>
                </div>
                <div className={'column ' + (wideText ? 'col-sm-12' : '') + ' col-4 text-right'}>
                    <div className="h5" style={{ fontSize: '250%', lineHeight: 1 }}>
                        { parseInt(Math.round((occupancy / max_occupancy * 100))) }%
                    </div>
                    <div className="h5" style={{ fontSize: '130%' }}>
                        {occupancy}/{max_occupancy} {translate(language, 'persons')}
                    </div>
                </div>
            </div>
        </div>

    </React.Fragment>;
};

export default OccupancyHeaderWithLimits;